/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountDTO,
  AccountRequestDto,
  AccountStatementDto,
  GetCustomerAccountsParams,
  GetLoanEligibilityParams,
  GetLoanLegerCardParams,
  LoanAccount,
  LoanEligibilityResponseDTO,
  ProductDTO,
  ResponseDataVoid,
  TransactionDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get account statement for a specific account
 * @summary Get statement
 */
export const getStatement = (
    branch: string,
    custNo: string,
    accountRequestDto: AccountRequestDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccountStatementDto>(
      {url: `/api/frontend/customer-accounts/${branch}/${custNo}/statement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountRequestDto, signal
    },
      options);
    }
  


export const getGetStatementMutationOptions = <TError = ResponseDataVoid,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStatement>>, TError,{branch: string;custNo: string;data: AccountRequestDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getStatement>>, TError,{branch: string;custNo: string;data: AccountRequestDto}, TContext> => {

const mutationKey = ['getStatement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStatement>>, {branch: string;custNo: string;data: AccountRequestDto}> = (props) => {
          const {branch,custNo,data} = props ?? {};

          return  getStatement(branch,custNo,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetStatementMutationResult = NonNullable<Awaited<ReturnType<typeof getStatement>>>
    export type GetStatementMutationBody = AccountRequestDto
    export type GetStatementMutationError = ResponseDataVoid

    /**
 * @summary Get statement
 */
export const useGetStatement = <TError = ResponseDataVoid,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStatement>>, TError,{branch: string;custNo: string;data: AccountRequestDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStatement>>,
        TError,
        {branch: string;custNo: string;data: AccountRequestDto},
        TContext
      > => {

      const mutationOptions = getGetStatementMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Request full statement to be sent to email
 * @summary Get full statement
 */
export const getFullStatement = (
    branch: string,
    custNo: string,
    accountRequestDto: AccountRequestDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ResponseDataVoid>(
      {url: `/api/frontend/customer-accounts/${branch}/${custNo}/full-statement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountRequestDto, signal
    },
      options);
    }
  


export const getGetFullStatementMutationOptions = <TError = ResponseDataVoid,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFullStatement>>, TError,{branch: string;custNo: string;data: AccountRequestDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getFullStatement>>, TError,{branch: string;custNo: string;data: AccountRequestDto}, TContext> => {

const mutationKey = ['getFullStatement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFullStatement>>, {branch: string;custNo: string;data: AccountRequestDto}> = (props) => {
          const {branch,custNo,data} = props ?? {};

          return  getFullStatement(branch,custNo,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetFullStatementMutationResult = NonNullable<Awaited<ReturnType<typeof getFullStatement>>>
    export type GetFullStatementMutationBody = AccountRequestDto
    export type GetFullStatementMutationError = ResponseDataVoid

    /**
 * @summary Get full statement
 */
export const useGetFullStatement = <TError = ResponseDataVoid,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFullStatement>>, TError,{branch: string;custNo: string;data: AccountRequestDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFullStatement>>,
        TError,
        {branch: string;custNo: string;data: AccountRequestDto},
        TContext
      > => {

      const mutationOptions = getGetFullStatementMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get customer accounts by product type
 * @summary Get customer accounts
 */
export const getCustomerAccounts = (
    branch: string,
    custNo: string,
    params: GetCustomerAccountsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/frontend/customer-accounts/${branch}/${custNo}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCustomerAccountsInfiniteQueryKey = (branch?: string,
    custNo?: string,
    params?: GetCustomerAccountsParams,) => {
    return [
    'infinite', `/api/frontend/customer-accounts/${branch}/${custNo}`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetCustomerAccountsQueryKey = (branch?: string,
    custNo?: string,
    params?: GetCustomerAccountsParams,) => {
    return [
    `/api/frontend/customer-accounts/${branch}/${custNo}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCustomerAccountsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCustomerAccounts>>>, TError = ResponseDataVoid>(branch: string,
    custNo: string,
    params: GetCustomerAccountsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerAccountsInfiniteQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAccounts>>> = ({ signal }) => getCustomerAccounts(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerAccountsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerAccounts>>>
export type GetCustomerAccountsInfiniteQueryError = ResponseDataVoid


export function useGetCustomerAccountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerAccounts>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params: GetCustomerAccountsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAccounts>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerAccountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerAccounts>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params: GetCustomerAccountsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAccounts>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerAccountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerAccounts>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params: GetCustomerAccountsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer accounts
 */

export function useGetCustomerAccountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerAccounts>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params: GetCustomerAccountsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerAccountsInfiniteQueryOptions(branch,custNo,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCustomerAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerAccounts>>, TError = ResponseDataVoid>(branch: string,
    custNo: string,
    params: GetCustomerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerAccountsQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAccounts>>> = ({ signal }) => getCustomerAccounts(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerAccounts>>>
export type GetCustomerAccountsQueryError = ResponseDataVoid


export function useGetCustomerAccounts<TData = Awaited<ReturnType<typeof getCustomerAccounts>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params: GetCustomerAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAccounts>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerAccounts<TData = Awaited<ReturnType<typeof getCustomerAccounts>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params: GetCustomerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAccounts>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerAccounts<TData = Awaited<ReturnType<typeof getCustomerAccounts>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params: GetCustomerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer accounts
 */

export function useGetCustomerAccounts<TData = Awaited<ReturnType<typeof getCustomerAccounts>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params: GetCustomerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerAccountsQueryOptions(branch,custNo,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get customer accounts that have at least one transaction in memtrans
 * @summary Get customer accounts with transactions
 */
export const getCustomerAccountsWithTransactions = (
    branch: string,
    custNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/frontend/customer-accounts/${branch}/${custNo}/with-transactions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCustomerAccountsWithTransactionsInfiniteQueryKey = (branch?: string,
    custNo?: string,) => {
    return [
    'infinite', `/api/frontend/customer-accounts/${branch}/${custNo}/with-transactions`
    ] as const;
    }

export const getGetCustomerAccountsWithTransactionsQueryKey = (branch?: string,
    custNo?: string,) => {
    return [
    `/api/frontend/customer-accounts/${branch}/${custNo}/with-transactions`
    ] as const;
    }

    
export const getGetCustomerAccountsWithTransactionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>>, TError = ResponseDataVoid>(branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerAccountsWithTransactionsInfiniteQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>> = ({ signal }) => getCustomerAccountsWithTransactions(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerAccountsWithTransactionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>>
export type GetCustomerAccountsWithTransactionsInfiniteQueryError = ResponseDataVoid


export function useGetCustomerAccountsWithTransactionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerAccountsWithTransactionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerAccountsWithTransactionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer accounts with transactions
 */

export function useGetCustomerAccountsWithTransactionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerAccountsWithTransactionsInfiniteQueryOptions(branch,custNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCustomerAccountsWithTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError = ResponseDataVoid>(branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerAccountsWithTransactionsQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>> = ({ signal }) => getCustomerAccountsWithTransactions(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerAccountsWithTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>>
export type GetCustomerAccountsWithTransactionsQueryError = ResponseDataVoid


export function useGetCustomerAccountsWithTransactions<TData = Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerAccountsWithTransactions<TData = Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerAccountsWithTransactions<TData = Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer accounts with transactions
 */

export function useGetCustomerAccountsWithTransactions<TData = Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAccountsWithTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerAccountsWithTransactionsQueryOptions(branch,custNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get loan transactions for a customer
 * @summary Get loan transactions
 */
export const getLoanTransactions = (
    branch: string,
    custNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TransactionDTO>(
      {url: `/api/frontend/customer-accounts/${branch}/${custNo}/loan-transactions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLoanTransactionsInfiniteQueryKey = (branch?: string,
    custNo?: string,) => {
    return [
    'infinite', `/api/frontend/customer-accounts/${branch}/${custNo}/loan-transactions`
    ] as const;
    }

export const getGetLoanTransactionsQueryKey = (branch?: string,
    custNo?: string,) => {
    return [
    `/api/frontend/customer-accounts/${branch}/${custNo}/loan-transactions`
    ] as const;
    }

    
export const getGetLoanTransactionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoanTransactions>>>, TError = ResponseDataVoid>(branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanTransactionsInfiniteQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanTransactions>>> = ({ signal }) => getLoanTransactions(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanTransactionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanTransactions>>>
export type GetLoanTransactionsInfiniteQueryError = ResponseDataVoid


export function useGetLoanTransactionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanTransactions>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanTransactions>>,
          TError,
          Awaited<ReturnType<typeof getLoanTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanTransactionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanTransactions>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanTransactions>>,
          TError,
          Awaited<ReturnType<typeof getLoanTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanTransactionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanTransactions>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan transactions
 */

export function useGetLoanTransactionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanTransactions>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanTransactionsInfiniteQueryOptions(branch,custNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoanTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getLoanTransactions>>, TError = ResponseDataVoid>(branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanTransactionsQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanTransactions>>> = ({ signal }) => getLoanTransactions(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanTransactions>>>
export type GetLoanTransactionsQueryError = ResponseDataVoid


export function useGetLoanTransactions<TData = Awaited<ReturnType<typeof getLoanTransactions>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanTransactions>>,
          TError,
          Awaited<ReturnType<typeof getLoanTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanTransactions<TData = Awaited<ReturnType<typeof getLoanTransactions>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanTransactions>>,
          TError,
          Awaited<ReturnType<typeof getLoanTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanTransactions<TData = Awaited<ReturnType<typeof getLoanTransactions>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan transactions
 */

export function useGetLoanTransactions<TData = Awaited<ReturnType<typeof getLoanTransactions>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanTransactionsQueryOptions(branch,custNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get loan ledger card for a specific loan
 * @summary Get loan ledger card
 */
export const getLoanLegerCard = (
    branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params?: GetLoanLegerCardParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanAccount>(
      {url: `/api/frontend/customer-accounts/${branch}/${custNo}/loan-ledger/${glNo}/${loanStatementType}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetLoanLegerCardInfiniteQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    loanStatementType?: string,
    params?: GetLoanLegerCardParams,) => {
    return [
    'infinite', `/api/frontend/customer-accounts/${branch}/${custNo}/loan-ledger/${glNo}/${loanStatementType}`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetLoanLegerCardQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,
    loanStatementType?: string,
    params?: GetLoanLegerCardParams,) => {
    return [
    `/api/frontend/customer-accounts/${branch}/${custNo}/loan-ledger/${glNo}/${loanStatementType}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanLegerCardInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoanLegerCard>>>, TError = ResponseDataVoid>(branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params?: GetLoanLegerCardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanLegerCardInfiniteQueryKey(branch,custNo,glNo,loanStatementType,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanLegerCard>>> = ({ signal }) => getLoanLegerCard(branch,custNo,glNo,loanStatementType,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo && loanStatementType), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanLegerCardInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanLegerCard>>>
export type GetLoanLegerCardInfiniteQueryError = ResponseDataVoid


export function useGetLoanLegerCardInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanLegerCard>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params: undefined |  GetLoanLegerCardParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanLegerCard>>,
          TError,
          Awaited<ReturnType<typeof getLoanLegerCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanLegerCardInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanLegerCard>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params?: GetLoanLegerCardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanLegerCard>>,
          TError,
          Awaited<ReturnType<typeof getLoanLegerCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanLegerCardInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanLegerCard>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params?: GetLoanLegerCardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan ledger card
 */

export function useGetLoanLegerCardInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanLegerCard>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params?: GetLoanLegerCardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanLegerCardInfiniteQueryOptions(branch,custNo,glNo,loanStatementType,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoanLegerCardQueryOptions = <TData = Awaited<ReturnType<typeof getLoanLegerCard>>, TError = ResponseDataVoid>(branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params?: GetLoanLegerCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanLegerCardQueryKey(branch,custNo,glNo,loanStatementType,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanLegerCard>>> = ({ signal }) => getLoanLegerCard(branch,custNo,glNo,loanStatementType,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo && loanStatementType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanLegerCardQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanLegerCard>>>
export type GetLoanLegerCardQueryError = ResponseDataVoid


export function useGetLoanLegerCard<TData = Awaited<ReturnType<typeof getLoanLegerCard>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params: undefined |  GetLoanLegerCardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanLegerCard>>,
          TError,
          Awaited<ReturnType<typeof getLoanLegerCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanLegerCard<TData = Awaited<ReturnType<typeof getLoanLegerCard>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params?: GetLoanLegerCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanLegerCard>>,
          TError,
          Awaited<ReturnType<typeof getLoanLegerCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanLegerCard<TData = Awaited<ReturnType<typeof getLoanLegerCard>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params?: GetLoanLegerCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan ledger card
 */

export function useGetLoanLegerCard<TData = Awaited<ReturnType<typeof getLoanLegerCard>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string,
    loanStatementType: string,
    params?: GetLoanLegerCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanLegerCard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanLegerCardQueryOptions(branch,custNo,glNo,loanStatementType,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get loan eligibility for a customer with optional product selection
 * @summary Get loan eligibility
 */
export const getLoanEligibility = (
    branch: string,
    custNo: string,
    params?: GetLoanEligibilityParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanEligibilityResponseDTO>(
      {url: `/api/frontend/customer-accounts/${branch}/${custNo}/loan-eligibility`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetLoanEligibilityInfiniteQueryKey = (branch?: string,
    custNo?: string,
    params?: GetLoanEligibilityParams,) => {
    return [
    'infinite', `/api/frontend/customer-accounts/${branch}/${custNo}/loan-eligibility`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetLoanEligibilityQueryKey = (branch?: string,
    custNo?: string,
    params?: GetLoanEligibilityParams,) => {
    return [
    `/api/frontend/customer-accounts/${branch}/${custNo}/loan-eligibility`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanEligibilityInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibility>>>, TError = ResponseDataVoid>(branch: string,
    custNo: string,
    params?: GetLoanEligibilityParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanEligibilityInfiniteQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanEligibility>>> = ({ signal }) => getLoanEligibility(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanEligibilityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanEligibility>>>
export type GetLoanEligibilityInfiniteQueryError = ResponseDataVoid


export function useGetLoanEligibilityInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibility>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params: undefined |  GetLoanEligibilityParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibility>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibility>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibilityInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibility>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params?: GetLoanEligibilityParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibility>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibility>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibilityInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibility>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params?: GetLoanEligibilityParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan eligibility
 */

export function useGetLoanEligibilityInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibility>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params?: GetLoanEligibilityParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanEligibilityInfiniteQueryOptions(branch,custNo,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoanEligibilityQueryOptions = <TData = Awaited<ReturnType<typeof getLoanEligibility>>, TError = ResponseDataVoid>(branch: string,
    custNo: string,
    params?: GetLoanEligibilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanEligibilityQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanEligibility>>> = ({ signal }) => getLoanEligibility(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanEligibilityQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanEligibility>>>
export type GetLoanEligibilityQueryError = ResponseDataVoid


export function useGetLoanEligibility<TData = Awaited<ReturnType<typeof getLoanEligibility>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params: undefined |  GetLoanEligibilityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibility>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibility>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibility<TData = Awaited<ReturnType<typeof getLoanEligibility>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params?: GetLoanEligibilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibility>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibility>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibility<TData = Awaited<ReturnType<typeof getLoanEligibility>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params?: GetLoanEligibilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan eligibility
 */

export function useGetLoanEligibility<TData = Awaited<ReturnType<typeof getLoanEligibility>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    params?: GetLoanEligibilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibility>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanEligibilityQueryOptions(branch,custNo,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get all available loan cycles for a customer's loan account
 * @summary Get loan cycles
 */
export const getLoanCycles = (
    branch: string,
    custNo: string,
    glNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number[]>(
      {url: `/api/frontend/customer-accounts/${branch}/${custNo}/loan-cycles/${glNo}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLoanCyclesInfiniteQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,) => {
    return [
    'infinite', `/api/frontend/customer-accounts/${branch}/${custNo}/loan-cycles/${glNo}`
    ] as const;
    }

export const getGetLoanCyclesQueryKey = (branch?: string,
    custNo?: string,
    glNo?: string,) => {
    return [
    `/api/frontend/customer-accounts/${branch}/${custNo}/loan-cycles/${glNo}`
    ] as const;
    }

    
export const getGetLoanCyclesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoanCycles>>>, TError = ResponseDataVoid>(branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanCyclesInfiniteQueryKey(branch,custNo,glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanCycles>>> = ({ signal }) => getLoanCycles(branch,custNo,glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanCyclesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanCycles>>>
export type GetLoanCyclesInfiniteQueryError = ResponseDataVoid


export function useGetLoanCyclesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanCycles>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanCycles>>,
          TError,
          Awaited<ReturnType<typeof getLoanCycles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanCyclesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanCycles>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanCycles>>,
          TError,
          Awaited<ReturnType<typeof getLoanCycles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanCyclesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanCycles>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan cycles
 */

export function useGetLoanCyclesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanCycles>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanCyclesInfiniteQueryOptions(branch,custNo,glNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoanCyclesQueryOptions = <TData = Awaited<ReturnType<typeof getLoanCycles>>, TError = ResponseDataVoid>(branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanCyclesQueryKey(branch,custNo,glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanCycles>>> = ({ signal }) => getLoanCycles(branch,custNo,glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanCyclesQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanCycles>>>
export type GetLoanCyclesQueryError = ResponseDataVoid


export function useGetLoanCycles<TData = Awaited<ReturnType<typeof getLoanCycles>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanCycles>>,
          TError,
          Awaited<ReturnType<typeof getLoanCycles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanCycles<TData = Awaited<ReturnType<typeof getLoanCycles>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanCycles>>,
          TError,
          Awaited<ReturnType<typeof getLoanCycles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanCycles<TData = Awaited<ReturnType<typeof getLoanCycles>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan cycles
 */

export function useGetLoanCycles<TData = Awaited<ReturnType<typeof getLoanCycles>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanCycles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanCyclesQueryOptions(branch,custNo,glNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get all account balances for a customer
 * @summary Get all account balances
 */
export const getAllAccountBalances = (
    branch: string,
    custNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TransactionDTO[]>(
      {url: `/api/frontend/customer-accounts/${branch}/${custNo}/balances`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllAccountBalancesInfiniteQueryKey = (branch?: string,
    custNo?: string,) => {
    return [
    'infinite', `/api/frontend/customer-accounts/${branch}/${custNo}/balances`
    ] as const;
    }

export const getGetAllAccountBalancesQueryKey = (branch?: string,
    custNo?: string,) => {
    return [
    `/api/frontend/customer-accounts/${branch}/${custNo}/balances`
    ] as const;
    }

    
export const getGetAllAccountBalancesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountBalances>>>, TError = ResponseDataVoid>(branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAccountBalancesInfiniteQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAccountBalances>>> = ({ signal }) => getAllAccountBalances(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllAccountBalancesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAccountBalances>>>
export type GetAllAccountBalancesInfiniteQueryError = ResponseDataVoid


export function useGetAllAccountBalancesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountBalances>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountBalances>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountBalancesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountBalances>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountBalances>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountBalancesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountBalances>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all account balances
 */

export function useGetAllAccountBalancesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountBalances>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllAccountBalancesInfiniteQueryOptions(branch,custNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllAccountBalancesQueryOptions = <TData = Awaited<ReturnType<typeof getAllAccountBalances>>, TError = ResponseDataVoid>(branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAccountBalancesQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAccountBalances>>> = ({ signal }) => getAllAccountBalances(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllAccountBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAccountBalances>>>
export type GetAllAccountBalancesQueryError = ResponseDataVoid


export function useGetAllAccountBalances<TData = Awaited<ReturnType<typeof getAllAccountBalances>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountBalances>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountBalances<TData = Awaited<ReturnType<typeof getAllAccountBalances>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountBalances>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountBalances<TData = Awaited<ReturnType<typeof getAllAccountBalances>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all account balances
 */

export function useGetAllAccountBalances<TData = Awaited<ReturnType<typeof getAllAccountBalances>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountBalances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllAccountBalancesQueryOptions(branch,custNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get balance for a specific product
 * @summary Get balance by product
 */
export const getBalanceByProduct = (
    branch: string,
    custNo: string,
    product: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccountDTO>(
      {url: `/api/frontend/customer-accounts/${branch}/${custNo}/balance/${product}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetBalanceByProductInfiniteQueryKey = (branch?: string,
    custNo?: string,
    product?: string,) => {
    return [
    'infinite', `/api/frontend/customer-accounts/${branch}/${custNo}/balance/${product}`
    ] as const;
    }

export const getGetBalanceByProductQueryKey = (branch?: string,
    custNo?: string,
    product?: string,) => {
    return [
    `/api/frontend/customer-accounts/${branch}/${custNo}/balance/${product}`
    ] as const;
    }

    
export const getGetBalanceByProductInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBalanceByProduct>>>, TError = ResponseDataVoid>(branch: string,
    custNo: string,
    product: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBalanceByProductInfiniteQueryKey(branch,custNo,product);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBalanceByProduct>>> = ({ signal }) => getBalanceByProduct(branch,custNo,product, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && product), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBalanceByProductInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBalanceByProduct>>>
export type GetBalanceByProductInfiniteQueryError = ResponseDataVoid


export function useGetBalanceByProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBalanceByProduct>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    product: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalanceByProduct>>,
          TError,
          Awaited<ReturnType<typeof getBalanceByProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBalanceByProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBalanceByProduct>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    product: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalanceByProduct>>,
          TError,
          Awaited<ReturnType<typeof getBalanceByProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBalanceByProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBalanceByProduct>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    product: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get balance by product
 */

export function useGetBalanceByProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBalanceByProduct>>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    product: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBalanceByProductInfiniteQueryOptions(branch,custNo,product,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetBalanceByProductQueryOptions = <TData = Awaited<ReturnType<typeof getBalanceByProduct>>, TError = ResponseDataVoid>(branch: string,
    custNo: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBalanceByProductQueryKey(branch,custNo,product);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBalanceByProduct>>> = ({ signal }) => getBalanceByProduct(branch,custNo,product, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo && product), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBalanceByProductQueryResult = NonNullable<Awaited<ReturnType<typeof getBalanceByProduct>>>
export type GetBalanceByProductQueryError = ResponseDataVoid


export function useGetBalanceByProduct<TData = Awaited<ReturnType<typeof getBalanceByProduct>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    product: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalanceByProduct>>,
          TError,
          Awaited<ReturnType<typeof getBalanceByProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBalanceByProduct<TData = Awaited<ReturnType<typeof getBalanceByProduct>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalanceByProduct>>,
          TError,
          Awaited<ReturnType<typeof getBalanceByProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBalanceByProduct<TData = Awaited<ReturnType<typeof getBalanceByProduct>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get balance by product
 */

export function useGetBalanceByProduct<TData = Awaited<ReturnType<typeof getBalanceByProduct>>, TError = ResponseDataVoid>(
 branch: string,
    custNo: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceByProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBalanceByProductQueryOptions(branch,custNo,product,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




